"use client";
import BuyNowCart from "@/components/common/BuyNowCart";
import SignupForFree from "@/components/landingpage/SignupForFree";
import NewMainLayout from "@/components/layout/newMainLayout";
import Collection from "@/components/rarestproduct/Collection";
import FlavourWheel from "@/components/rarestproduct/FlavourWheel";
import ProductPortEllenFold from "@/components/rarestproduct/ProductPortEllenFold";
import SliderSection from "@/components/rarestproduct/SliderSection";
import TheCask from "@/components/rarestproduct/TheCask";
import TheCollection from "@/components/rarestproduct/TheCollection";
import TheOctaveProductDetails from "@/components/rarestproduct/TheOctaveProductDetails";
import TheTestingNotes from "@/components/rarestproduct/TheTestingNotes";
import ScoMeta from "@/components/scometa";
import { getCheckoutLineItems } from "@/util/utils";
import { useAppCommonStore } from "@/zustand/appCommon";
import React, { useEffect, useState } from "react";

const ProductDetails = (props: any) => {
  const { data, meta } = props;
  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));

  const [productDetailsData, setproductDetailsData]: any = useState(
    []
  );

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  useEffect(() => {
    if (data) {
      setproductDetailsData(data?.data?.attributes);
    }
  }, [data]);

  const renderProductDetailsPage = () => {
    return (
      <>
        {productDetailsData?.blocks &&
        productDetailsData?.blocks.length
          ? productDetailsData?.blocks.map(
              (content: any, index: any) => {
                switch (content.__component) {
                  case "product.info-section":
                    return (
                      <div id="details">
                        <TheCollection
                          key={content?.id + index}
                          data={content}
                        />
                      </div>
                    );

                  case "product.tasting-octave":
                    return (
                      <>
                        {content?.is_active === true && (
                          <TheTestingNotes
                            key={content?.id + index}
                            data={content}
                          />
                        )}
                      </>
                    );
                  case "product.tasting-notes":
                    return (
                      <>
                        {content?.is_active === true && (
                          <TheTestingNotes
                            key={content?.id + index}
                            data={content}
                          />
                          // <TestingNote key={content?.id + index} data={content} />
                        )}
                      </>
                    );

                  case "product.flavour-wheel":
                    return (
                      <FlavourWheel
                        key={content?.id + index}
                        data={content}
                      />
                    );

                  case "product.info-section2":
                    return (
                      <>
                        {content?.is_active === true && (
                          <TheCask
                            key={content?.id + index}
                            data={content}
                          />
                        )}
                      </>
                    );
                  case "product.product-detail":
                    return (
                      <TheOctaveProductDetails
                        key={content?.id + index}
                        data={content}
                      />
                    );

                  case "product.discover-more":
                    return (
                      <Collection
                        key={content?.id + index}
                        data={content}
                        countryCode={selectedCountry.value}
                      />
                    );
                  case "product.gallery":
                    return (
                      <>
                        {content?.is_active === true && (
                          <SliderSection
                            key={content?.id + index}
                            data={content}
                          />
                        )}
                      </>
                    );
                  default:
                    return null;
                }
              }
            )
          : null}
      </>
    );
  };

  return (
    <>
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      <head>
        <ScoMeta meta={meta ? meta : {}} />
      </head>
      {productDetailsData && (
        <NewMainLayout
          checkout={checkout}
          toggleCartSidebar={toggleCartSidebar}
        >
          <div className="product-container">
            <ProductPortEllenFold
              data={productDetailsData}
              countryCode={selectedCountry.value}
              checkout={checkout}
              setCheckout={setCheckout}
            />
            {productDetailsData && renderProductDetailsPage()}

            <SignupForFree />
          </div>
        </NewMainLayout>
      )}
    </>
  );
};

export default ProductDetails;
